import { mapState as rootMapState } from 'pinia';
import { mapState, mapActions } from '@/store/helpers';
import { usePageStore } from '@/store';
import { getSnapshotListing } from '@/modules/md-listing-list/api';
import * as TYPES from './_store/types';
import { formats } from '../../common/format/index';
import util from '../../common/util';
import { normalizeParams } from './_center-adaptor/normalizeParams';
import { subModulesMixin  } from './subModules';
export default {
    i18next: {
        ns: 'md-search-result'
    },
    mixins: [subModulesMixin],
    data: function() {
        return {
            recentSoldListings: [],
            recentSoldCount: 0,
            hideQuickSearch: false,
        };
    },
    props: {
        searchCount: {
            default: ''
        },
        breadCrumbs: {
            default: []
        },
        hideBelow: {
            default: false
        }
    },
    inject: {
        // footerData: 'footerData',
        id: 'id'
    },
    computed: {
        ...mapState({
            "keywords": store => store.keywords,
            "result": store => store.result,
            "searchParams": store => store.searchParams,
            "averageStoreData": store => store.averageData
        }),
        ...rootMapState(usePageStore, {
            "global": store => store.page || {},
            "isSearchCenter": store => store.page.searchCenter,
            "currencySymbol": store => store.currency.symbol
        }),
        average({ averageStoreData }) {
            return averageStoreData?.avgResultList || [];
        },
        activeCounts({ averageStoreData }) {
            return averageStoreData.counts || 0;
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        location() {
            return this.keywords[0] || {};
        },
        lastLevelLocation() {
            return [...this.breadCrumbs].pop() || {};
        },
        count() {
            return this.result.counts;
        },
        averageData({ average }) {
            return average.reduce((memo, cur) => {
                let { key, value } = cur;
                value = this.processAverageData(key, value);
                memo[key] = value;
                return memo;
            }, {});
        },
        marketReportTitle() {
            return this.lastLevelLocation.name
                ? this.$t('md-search-result.marketSnapshotIn', {
                    name: this.lastLevelLocation.name.toUpperCase()
                })
                : this.$t('md-search-result.marketSnapshot');
        },
        marketTrendsExtraTitle() {
            return this.lastLevelLocation.name
                ? this.$t('md-search-result.inLocation', {
                    name: this.lastLevelLocation.name.toUpperCase()
                })
                : '';
        },
        recentSoldTitle() {
            return this.lastLevelLocation.name
                ? this.$t('md-search-result.recentSoldListingsIn', {
                    name: this.lastLevelLocation.name.toUpperCase()
                })
                : this.$t('md-search-result.recentSoldListings');
        },
        snapshotLink() {
            const { keyword: key, keywordType } = this.location;
            return util.setQueryField(
                normalizeParams(
                    this.isSearchCenter,
                    {
                        key,
                        keywordType
                    },
                    {},
                    { needKey: true }
                ),
                '/snapshot'
            );
        }
    },
    methods: {
        ...mapActions({
            "updateUrl": TYPES.UPDATE_URL,
            "prevViewPatternMutation": TYPES.PREV_VIEW_PATTERN_MUTATION,
            "setShowInsight": TYPES.SHOW_INSIGHT_UPDATE_MUTATION
        }),
        
        
        getAverageDataLabel(value, label) {
            if (!value) {
                return ''; 
            }
            if (label === 'sqft') {
                return this.$t('md-search-result.sqft', {
                    num: this.formatNumber(value)
                }); 
            }
            return this.$t(`md-search-result.${label}`, { count: value });
        },
        processAverageData(key, value) {
            value = Number(value);
            if (!value) {
                return 0; 
            }
            if (key === 'price') {
                return parseInt(value / 1000) * 1000;
            } else {
                return Number(value.toFixed(1));
            }
        },
        hideInSight() {
            this.setShowInsight({ isShow: false, isMobile: this.isMobileSize });
            this.updateUrl();
        },
        fetchMarketReportData() {
            this.$refs.marketReport &&
                this.$refs.marketReport.getInsightMarketData(
                    this.getLocationParams()
                );
        },
        getLocationParams() {
            return normalizeParams(
                this.isSearchCenter,
                {
                    key: this.location.keyword,
                    keywordType: this.location.keywordType
                },
                {},
                { needKey: true }
            );
        },
        fetchMarketTrendsData() {
            const getData = () => {
                this.$refs.marketTrends &&
                    this.$refs.marketTrends.getDataByCondition(
                        this.getLocationParams()
                    );
            };
            getData();
        },
        async fetchRecentSoldData() {
            if (!this.location) {
                return; 
            }
            let params = {
                'sold-date': 180,
                key: this.location.keyword,
                keywordType: this.location.keywordType,
                listingStatus: 'Sold'
            };
            try {
                const ret = await getSnapshotListing.call(this, params, this.global);
                this.recentSoldListings = ret.listings.slice(0, 3);
                this.recentSoldCount = ret.counts;
            } catch (e) {
                console.log(e);
            }
        },
        formatNumber(number) {
            return formats.number(number);
        }
    },
    created() {
        //  this.getAverageData();
    },
    mounted() {
        this.fetchMarketReportData();
        this.fetchMarketTrendsData();
        this.fetchRecentSoldData();
    }
};
